import { useState } from 'react'
import { GInputFile } from 'tennders-common/form/components'
import useTranslation from 'next-translate/useTranslation'

const useMultipleCostInvoicePreview = () => {
  const { t } = useTranslation()
  const [documents, setDocuments] = useState<any>([])

  const addButton = (
    <GInputFile
      params={{}}
      next={(data) => setDocuments([{ ...data, deletable: true }, ...documents])}
      url="/documents"
      buttonClass="btn-border standard-btn "
    >
      {t('costInvoice:uploadFile')}
    </GInputFile>
  )

  return { addButton, documents, setDocuments }
}

export default useMultipleCostInvoicePreview
